module.exports = __webpack_public_path__ + "static/media/agriculture.9607a740.jpg";